<mat-progress-bar *ngIf="showLoader" style="margin-top: 2px;" class="col-md-12" mode="indeterminate"></mat-progress-bar>
<div class="">
  <!-- <h2 class="title pb-3 d-inline-flex">{{Header}}</h2> -->
  <button type="button" class="close closeModal" aria-label="Close" mat-dialog-close>
    <img src="./assets/close_side_nav.png">
  </button>

  <mat-dialog-content>
    <div *ngIf="blobUrl">
      <div style="padding-bottom: 30px;">
        <button class="forsubmit schBtn button-right1" (click)="downloadpdffile2()">Download</button>
      </div>
      <pdf-viewer [src]="safeurl?.changingThisBreaksApplicationSecurity" [original-size]="false"></pdf-viewer>
    </div>
  </mat-dialog-content>
</div>
